// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__ybHn4","divider":"Index_divider__3UyhT"};